export default __webpack_public_path__ + "static/media/Energera_FullLogo_Dark.a95aeee4.png";